"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecondaryNavigation = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const NavContainer = Theme_1.styled.div `
  width: ${(props) => props.width || '100%'};
  height: ${(props) => props.height || '40px'};
  display: inline-flex;
  background: #ffff;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px #eeeeee solid;
  padding: 0px 64px;
  margin-top: 0px;
  margin-bottom: 0px;
  box-shadow: none;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-weight: 600;
`;
const Tab = Theme_1.styled.div `
  font-family:      ${(props) => props.theme.font.family.proximaNova};
  color:            #666666;
  padding:          6px 26px 6px 0;
  min-width:        0;
  font-size:        14px;
  line-height:      17px;
  font-weight:      ${(props) => (props.isSelected ? '900' : '500')};
  display:          inline;
  letter-spacing    ${(props) => (props.isSelected ? '0' : '-0.08px')};
  :hover {
    cursor:         pointer;
  }
`;
exports.SecondaryNavigation = (props) => {
    const [selectedIndex, setSelectedIndex] = react_1.default.useState(props.startingIndex || 0);
    const changedTab = (index, onClick) => {
        setSelectedIndex(index);
        onClick && onClick();
    };
    return (react_1.default.createElement(NavContainer, Object.assign({}, props), props.tabs.map((item, index) => (react_1.default.createElement(Tab, { isSelected: index === selectedIndex, onClick: () => changedTab(index, item.onClick), key: item.title }, item.title)))));
};
//# sourceMappingURL=SecondaryNavigation.js.map